<template>
	<div class="content-wrap">
		<div v-if="trainState == 'Passed'">
			<img src="../../../static/voicetrain.jpg" style="width: 100%;" />
		</div>
    <el-table v-else :data="list" border highlight-current-row style="width: 100%">
      <el-table-column prop="trainTitle" label="标题" align="center"></el-table-column>
      <el-table-column prop="trainDate" label="培训日期" align="center"></el-table-column>
      <el-table-column prop="trainSeqName" label="场次" align="center"></el-table-column>
      <el-table-column prop="customerNum" label="报名人数" align="center"></el-table-column>
      <el-table-column prop="applyState" label="状态" align="center">
      	<template slot-scope="scope">
      		<span>{{ scope.row.applyState ? '已报名' : '未报名' }}</span>
      	</template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
        	<a href="javascript:;" class="link-text" @click="showDetail(scope.row.trainId)">我要报名</a>
        </template>
      </el-table-column>
    </el-table>
    <!--报名-->
    <el-dialog title="我要报名" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-form :model="modal" ref="modal" label-width="120px">
        <el-form-item label="标题：">{{ modal.trainTitle }}</el-form-item>
        <el-form-item label="讲师：">{{ modal.teacherName }}</el-form-item>
        <el-form-item label="培训内容：">{{ modal.trainContent }}</el-form-item>
        <el-form-item label="引导内容：">{{ modal.guideContent }}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;display: block;">
        <el-button type="info" v-if="modal.applyState">已报名</el-button>
        <el-button type="primary" v-else @click="applyTrain">我要报名</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				list: [],
				trainId: '',
				trainState: '',
				content: '',
				modal: {
					trainTitle: '',
					teacherName: '',
					trainContent: '',
					guideContent: ''
				}
			}
		},
		mounted() {
			this.getList();
		},
		created() {
		    //小助手有个弹窗“培训通知----再考虑一下----报名”是跳这个界面，直接在界面改，跳到目标地址
			window.location.href = "/tjkStudy/train/index?type=SkillUpgrade&show=yes"
		},
		methods: {
			getList() {
				this.$http.post(API_ROOT.college + '/preWorkTrain/customer/queryTrainList').then(response => {
	        var result = response.data;
	        if(result.success) {
	        	this.content = result.data.content;
	        	this.trainState = result.data.trainState;
						this.list = result.data.trainList;
	        }else {
	          this.$alert(result.msg);
	        }
	      }, response => {
	        this.$alert('网络繁忙，请稍后重试！');
	      })
			},
			getDetail(trainId) {
				this.$http.post(API_ROOT.college + '/preWorkTrain/customer/getTrainDetail', {'trainId': trainId}).then(response => {
	        var result = response.data;
	        if(result.success) {
						this.modal = result.data;
	        }else {
	          this.$alert(result.msg);
	        }
	      }, response => {
	        this.$alert('网络繁忙，请稍后重试！');
	      })
			},
			showDetail(trainId) {
				this.trainId = trainId;
				this.getDetail(trainId);
				this.checkTrainState(trainId);
				this.dialogVisible = true;
			},
			//弹出层关闭
	    handleClose() {
	      this.$refs['modal'].resetFields();
	      this.dialogVisible = false;
	    },
	   	//检测是否存在其他报名信息
	    checkTrainState(trainId) {
	    	this.$http.post(API_ROOT.college + '/preWorkTrain/customer/checkTrainState', {'trainId': trainId}).then(response => {
	        var result = response.data;
	        if(result.success) {
						this.existApplyRecord = result.data.existApplyRecord;
						if(result.data.existApplyRecord) {
							this.oldTrainId = result.data.oldTrainId;
							this.oldTrainTitle = result.data.oldTrainTitle;
						}else {
							this.oldTrainId = '';
							this.oldTrainTitle = '';
						}
	        }else {
	          this.$alert(result.msg);
	        }
	      }, response => {
	        this.$alert('网络繁忙，请稍后重试！');
	      })
	    },
	    applyTrain() {
	    	let self = this;
	    	if(this.existApplyRecord) {
	    		this.$confirm('你已报名培训场次:'+ this.oldTrainTitle + '，是否确认并切换？', '提示', {
		        confirmButtonText: '确认并加群',
		        cancelButtonText: '取消',
		        type: 'warning'
		      }).then(() => {
		      	let data = {
		      		'trainId': this.trainId,
		      		'oldTrainId': this.oldTrainId
		      	}
		        self.$http.post(API_ROOT.college + '/preWorkTrain/customer/applyTrain', data).then(response => {
		          var result = response.data;
		          if(result.success) {
		            self.$message({
		              message: '操作成功',
		              type: 'success',
		              center: true,
		              duration: 1000
		            })
		            window.location.href = result.data.groupLink;
		          }else {
		            self.$alert(result.msg);
		          }
		        }, response => {
		          self.$alert('网络繁忙，请稍后重试！');
		        })
		      }).catch(() => {
		                 
		      })
	    	}else {
	    		this.$confirm('是否确认报名？', '提示', {
		        confirmButtonText: '确认并加群',
		        cancelButtonText: '取消',
		        type: 'warning'
		      }).then(() => {
		      	let data = {
		      		'trainId': this.trainId
		      	}
		        self.$http.post(API_ROOT.college + '/preWorkTrain/customer/applyTrain', data).then(response => {
		          var result = response.data;
		          if(result.success) {
		            self.$message({
		              message: '操作成功',
		              type: 'success',
		              center: true,
		              duration: 1000
		            })
		            window.location.href = result.data.groupLink;
		          }else {
		            self.$alert(result.msg);
		          }
		        }, response => {
		          self.$alert('网络繁忙，请稍后重试！');
		        })
		      }).catch(() => {
		                 
		      })
	    	}
	    }
		}
	}
</script>

<style lang="less" scoped="">
	.content-wrap {
		padding: 20px;
	}
	.link-text {
		display: inline-block;
    margin: 5px;
    cursor: pointer;
    color: #4297ff;
	}
</style>


// WEBPACK FOOTER //
// ./src/page/hawkeye/voiceTrain.vue